import { ICookieDialogState } from '../types';

export const COOKIE_DIALOG_LOCALSTORAGE = 'COOKIE_DIALOG_LOCALSTORAGE';

export interface ICookieDialogLocalStorage extends ICookieDialogState{
};
